import { userTypes } from '../actions/_actionTypes';
import { authTypes } from '../actions/_actionTypes';

function getCurrentUser(state, action) {
    if(action.payload){
        return {
            ...action.payload,
            loggedIn: true
        }
    } else {
        return { loggedIn: false };
    }
}

function loginFailure(state, action) {
    if(action.payload){
        return {
            error: action.payload,
            loggedIn: false
        }
    } else {
        return { loggedIn: false };
    }
}

function updateCredits(state, action){
    const { payload } = action
    const { gameCost } = payload;

    return {
        ...state,
        credits: state.credits - gameCost
    }
}

function updateNotifications(state, action){
    return {
        ...state,
        newNotificationCount: 0
    }
}


export default function (state = null, action) {
    switch(action.type)
    {
        case userTypes.FETCH_USER:
        case authTypes.LOGIN_SUCCESS:
        case authTypes.REGISTER_SUCCESS:
        case userTypes.EDIT_USER_SUCCESS:
            return getCurrentUser(state, action);
        case authTypes.LOGIN_FAILURE:
        case authTypes.REGISTER_FAILURE:
            return loginFailure(state, action);
        case userTypes.UPDATE_CREDITS:
            return updateCredits(state, action);
        case userTypes.UPDATE_NOTIFICATIONS:
            return updateNotifications(state, action);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user.reducer.js